import {
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_GUEST_INFORMATION,
    NODE_NAME_SALE_INFORMATION,
    NODE_NAME_ATTENDING,
    NODE_NAME_ADDITIONAL_GUEST_COUNT,
    NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP,
    NODE_NAME_ADDITIONAL_GUEST_INFO_GROUP,
    NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_LAST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_EMAIL,
    NODE_NAME_CHECK_IN,
    NODE_NAME_CHECK_OUT,
    NODE_NAME_FORM_CONTENT,
    NODE_NAME_CAPTCHA,
    NODE_NAME_SOCIAL_RSVP,
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_END_TIME,
} from 'common/entities/formNode/nodeNames';

/** @var {string[]} - names of form nodes that should be locked to editing. */
export const EDIT_LOCKED_NODE_NAMES = [NODE_NAME_GUEST_INFORMATION, NODE_NAME_SALE_INFORMATION, NODE_NAME_CAPTCHA];

// @TODO, change this to prevent all questions with `name` to be duplicated.
/** @var {string[]} - node names that are not duplicable. */
export const DUP_LOCKED_NODE_NAMES = [
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_GUEST_INFORMATION,
    NODE_NAME_SALE_INFORMATION,
    NODE_NAME_ATTENDING,
    NODE_NAME_ADDITIONAL_GUEST_COUNT,
    NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP,
    NODE_NAME_ADDITIONAL_GUEST_INFO_GROUP,
    NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_LAST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_EMAIL,
    NODE_NAME_CHECK_IN,
    NODE_NAME_CHECK_OUT,
    NODE_NAME_CAPTCHA,
    NODE_NAME_SOCIAL_RSVP,
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_TIME,
];

/** @var {string[]} - node names that their visibility can't be edited. */
export const VISIBILITY_LOCKED_NODE_NAMES = [
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_GUEST_INFORMATION,
    NODE_NAME_SALE_INFORMATION,
    NODE_NAME_FORM_CONTENT,
    NODE_NAME_CAPTCHA,
    NODE_NAME_SOCIAL_RSVP,
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_END_TIME,
];

/** @var {string[]} - names of form nodes that should be locked to change required. */
export const REQUIRED_LOCKED_NODE_NAMES = [NODE_NAME_FIRST_NAME, NODE_NAME_LAST_NAME, NODE_NAME_EMAIL];

/** @var {string[]} - names of form nodes that should be locked to deleting. */
export const DELETE_LOCKED_NODE_NAMES = [
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_GUEST_INFORMATION,
    NODE_NAME_SALE_INFORMATION,
    NODE_NAME_DATE_RANGE_START_DATE,
    NODE_NAME_DATE_RANGE_END_DATE,
    NODE_NAME_DATE_RANGE_START_TIME,
    NODE_NAME_DATE_RANGE_END_TIME,
];

/** @var {string[]} - names of form nodes that should be locked to dragging. */
export const DRAG_LOCKED_NODE_NAMES = [NODE_NAME_SOCIAL_RSVP];

/** @var {string[]} - names of form nodes that should not be allowed to be saved. */
export const SAVE_LOCKED_NODE_NAMES = [
    NODE_NAME_FIRST_NAME,
    NODE_NAME_LAST_NAME,
    NODE_NAME_EMAIL,
    NODE_NAME_GUEST_INFORMATION,
    NODE_NAME_SALE_INFORMATION,
    NODE_NAME_ATTENDING,
    NODE_NAME_ADDITIONAL_GUEST_COUNT,
    NODE_NAME_ADDITIONAL_GUEST_FIRST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_LAST_NAME,
    NODE_NAME_ADDITIONAL_GUEST_EMAIL,
    NODE_NAME_CHECK_IN,
    NODE_NAME_CHECK_OUT,
    NODE_NAME_CAPTCHA,
];

export const ADD_TEMPLATE_NODE_NAMES = [NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP, NODE_NAME_GUEST_INFORMATION];

export const ADD_TEMPLATE_ADDITIONAL = [NODE_NAME_ADDITIONAL_GUEST_TOP_GROUP];

export const TOP_BLOCKED_NODES = [NODE_NAME_SOCIAL_RSVP];

/** @var {string[]} - names of form nodes that should not be allowed to change input type. */
export const INPUT_TYPE_LOCKED_NODE_NAMES = [];
